import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import ViewForm from "./ViewForm";

const ViewSupplier = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{flexGrow:'1',overflow: "hidden"}}>

      <Helmet>
				<title>Supplier - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <ViewForm />
      </div>
      </div>
    </>
  );
};

export default ViewSupplier;
